module.exports = __webpack_public_path__ + "img/discount.2c18f17a.png";